import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    dialogPaper: {
      borderRadius: '25px',
      padding: '16px 26px',
      maxWidth: '652px',
      width: '100%',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid #EEEEEE'
    },
    title: {
      color: '#0047BA',
      fontSize: '24px',
      fontWeight: 'bold',
      fontFamily: 'Noto Sans',
    },
    subTitle: {
      color: '#0047BA',
      fontSize: '16px',
      fontWeight: 'bold',
      fontFamily: 'Noto Sans',
      marginBottom: '8px'
    },
    wrapperButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '25px',
    },
    button: {
      marginLeft: '8px',
    },
  })
);

export default useStyles;
